export const ORDER_FILE_LIMIT = 50;
export const TICKET_FILE_LIMIT = 10;